/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { gettingQuestionAction, gotQuestionAction, AppState } from '../Store';
import { getQuestion } from '../data';

import { Title } from '../components/Title';
import { Container, Typography, Breadcrumbs, Link, Chip, Stack } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

export const Question = () => {
    const dispatch = useDispatch();
    const question = useSelector((state: AppState) => state.questions.viewing);

    const { id } = useParams();
    const questionId = parseInt(id);
    const navigate = useNavigate();

    useEffect(() => {
        const doGetQuestion = async (questionId: number) => {
            dispatch(gettingQuestionAction());
            const foundQuestion = await getQuestion(questionId);
            dispatch(gotQuestionAction(foundQuestion));
        };
        if (questionId) {
            doGetQuestion(Number(questionId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questionId]);

    return (
        <>
            {question && <Title title={question.title} />}

            <Container maxWidth="md" css={css``}>
                <Breadcrumbs
                    aria-label="breadcrumb"
                    css={css`
                        padding: 20px 0;
                    `}
                >
                    <Link
                        color="inherit"
                        onClick={() => {
                            navigate('/');
                        }}
                        css={css`
                            display: flex;
                            cursor: pointer;
                        `}
                    >
                        <HomeIcon
                            css={css`
                                margin-right: 5px;
                                width: 20px;
                                height: 20px;
                            `}
                        />
                        Home
                    </Link>
                    <Typography>{question && question.categoryName}</Typography>
                </Breadcrumbs>

                <Typography variant="h4">{question && question.title}</Typography>

                {question && (
                    <>
                        {question.labels.trim().length > 0 && (
                            <Stack
                                direction="row"
                                spacing={1}
                                css={css`
                                    padding: 20px 0;
                                `}
                            >
                                {question.labels.split(',').map((label, idx) => {
                                    return <Chip key={idx} label={label.trim()} />;
                                })}
                            </Stack>
                        )}
                        <Typography variant="overline">Updated on {question.updated.toLocaleDateString()}</Typography>
                        <div
                            css={css`
                                padding: 5px 0;
                                margin-bottom: 30px;
                                border-bottom: 1px solid rgb(217, 233, 255);
                            `}
                        />
                        <div
                            css={css`
                                img {
                                    max-width: 100%;
                                }
                                pre {
                                    white-space: pre-wrap;
                                    word-wrap: break-word;
                                    text-align: justify;
                                }
                                padding-bottom: 2em;
                                a {
                                    color: #007bff;
                                    text-decoration: none;
                                    background-color: transparent;
                                }
                            `}
                            dangerouslySetInnerHTML={{ __html: question.content }}
                        ></div>
                    </>
                )}
            </Container>
        </>
    );
};
